import { useModelContext } from '@app/contexts/model';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

type TProps = {};

export const SelectMain: FunctionComponent<TProps> = observer(() => {
    const { translateStore } = useStorageTranslateContext();
    const { languageModel } = useModelContext();
    const { authorizationModel } = useModelContext();

    const user = authorizationModel.user.get();

    const categoryLangResponse = languageModel.dataCategory.get();

    return (
        <FormControl fullWidth>
            <InputLabel id={'source-language'}>Source language</InputLabel>
            <Select variant={'standard'} labelId='source-language' value={translateStore.mainLanguageId} label={'Select'} onChange={(e) => (translateStore.mainLanguageId = e.target.value)}>
                {categoryLangResponse &&
                    categoryLangResponse.main.map((value) => {
                        if (user.user.language_source.includes(value.key)) {
                            return (
                                <MenuItem key={value.key} value={value.key}>
                                    {value.name}
                                </MenuItem>
                            );
                        }
                    })}
            </Select>
        </FormControl>
    );
});
